// Copyright (c) 2017 Deere & Company

import * as busyCounter from './busy-counter';
import {getClaimTypes, getSubClaimTypes} from '../repositories';
import {getCombinedClaimTypes} from '../services/build-claim-types';

export const readClaimTypes = action =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            let claimTypes;

            claimTypes = await getClaimTypes();

            if (claimTypes.some(claimType => claimType.key === 'ZZMK')) {

                const subClaimTypes = await getSubClaimTypes();

                claimTypes = getCombinedClaimTypes(claimTypes, subClaimTypes);

            }

            dispatch({
                claimTypes,
                type: action
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/get-claim-types.js